
import React from 'react';
// import Home from '../../pages/Home';
// import Onboarding from '../../pages/Onboarding';

// import Dashboard from '../components/Dashboard';
// import DoctorProfile from '../components/DoctorProfile';
// import EditDoctorProfile from '../components/EditDoctorProfile';
// import MyAppoinment from '../components/MyAppoinment';
// import MyWorkingCalendar from '../components/MyWorkingCalendar';
// import PatientList from '../components/PatientList';
// import PatientProfile from '../components/PatientProfile';
// import PatientDetails from '../components/PatientDetails';
// import MySchedule from '../components/MySchedule';
// import PatientPrescription from '../components/PatientPrescription';
// import AdminPatientHealthForm from '../components/AdminPatientHealthForm';
// import PatientOtherAssesment from '../components/PatientOtherAssesment';
// import PatientMedicalHistory from '../components/PatientMedicalHistory';
// import AdminDashboard from '../AdminView/AdminDashboard';
// import Appointments from '../AdminView/Appointments';
// import NewSignUp from '../AdminView/NewSignUp';
// import Registrations from '../AdminView/Registrations';
// import Patients from '../AdminView/Patients';
// import Payments from '../AdminView/Payments';
// import Marketing from '../AdminView/Marketing';
// import ApprovedTherapists from '../AdminView/ApprovedTherapists';
// import ReassessmentImprovement from '../AdminView/ReassessmentImprovement';
// import AppointmentFeedback from '../AdminView/AppointmentFeedback';
// import TherapistReimbursementPaid from '../AdminView/TherapistReimbursementPaid';
// import AppointmentUnpaid from '../AdminView/AppointmentUnpaid';
// import TherapistReimbursementInfo from '../AdminView/TherapistReimbursementInfo';
// import AccountReceived from '../AdminView/AccountReceived';
// import AccountReceivable from '../AdminView/AccountReceivable';
// import FirstAppointment from '../AdminView/FirstAppointment';
// import AdminPatientHealthFormNew from '../AdminView/AdminPatientHealthFormNew';
// import Cervical from '../components/Cervical';
// import Lumbar from '../components/Lumbar';
// import LowerExtremities from '../components/LowerExtremities';
// import Thoracic from '../components/Thoracic';
// import UpperExtremities from '../components/UpperExtremities';
// import Vestibular from '../components/Vestibular';
// import Reassessment from '../components/Reassessment';
// import PatientRefuseAssessment from '../components/PatientRefuseAssessment';
// import PP_PatientDashboard from '../PatientView/PP_PatientDashboard';
// import PP_MyAppointments from '../PatientView/PP_MyAppointments';
// import PP_SuggestedVideo from '../PatientView/PP_SuggestedVideo';
// import PP_PatientMedicalHistory from '../PatientView/PP_PatientMedicalHistory';
// import PP_StartMeeting from '../PatientView/PP_StartMeeting';
// import PP_PatientBookAppointment from '../PatientView/PP_PatientBookAppointment';
// import CA_Dashboard from '../CompanyAdmin/CA_Dashboard';
// import CA_Overview from '../CompanyAdmin/CA_Overview';
// import CA_BookAnAppointment from '../CompanyAdmin/CA_BookAnAppointment';
// import CA_PatientNurse from '../CompanyAdmin/CA_PatientNurse';
// import RequestsForApppointment from '../AdminView/RequestsForApppointment';
// import PatientDischarge from '../AdminView/PatientDischarge';
// import PatientRefusal from '../AdminView/PatientRefusal';
// import ContactUs from '../AdminView/ContactUs';
// import AppointmentFees from '../AdminView/AppointmentFees';
// import SelfPayAppointment from '../AdminView/SelfPayAppointment';
// import PaymentConfirmation from '../PatientView/PaymentConfirmation';
const Dashboard = React.lazy(() => import('../components/Dashboard'));
const DoctorProfile = React.lazy(() => import('../components/DoctorProfile'));
const EditDoctorProfile = React.lazy(() => import('../components/EditDoctorProfile'));
const MyAppoinment = React.lazy(() => import('../components/MyAppoinment'));
const MyWorkingCalendar = React.lazy(() => import('../components/MyWorkingCalendar'));
const PatientList = React.lazy(() => import('../components/PatientList'));
const PatientProfile = React.lazy(() => import('../components/PatientProfile'));
const PatientDetails = React.lazy(() => import('../components/PatientDetails'));
const MySchedule = React.lazy(() => import('../components/MySchedule'));
const PatientPrescription = React.lazy(() => import('../components/PatientPrescription'));
const AdminPatientHealthForm = React.lazy(() => import('../components/AdminPatientHealthForm'));
const PatientOtherAssesment = React.lazy(() => import('../components/PatientOtherAssesment'));
const AssessmentTemplate = React.lazy(() => import('../components/AssessmentTemplate'));
const PatientMedicalHistory = React.lazy(() => import('../components/PatientMedicalHistory'));
const AdminDashboard = React.lazy(() => import('../AdminView/AdminDashboard'));
const Appointments = React.lazy(() => import('../AdminView/Appointments'));
const CAPrisonReport = React.lazy(() => import('../AdminView/CAPrisonReport'));
const NewSignUp = React.lazy(() => import('../AdminView/NewSignUp'));
const Registrations = React.lazy(() => import('../AdminView/Registrations'));
const Patients = React.lazy(() => import('../AdminView/Patients'));
const Payments = React.lazy(() => import('../AdminView/Payments'));
const Marketing = React.lazy(() => import('../AdminView/Marketing'));
const ApprovedTherapists = React.lazy(() => import('../AdminView/ApprovedTherapists'));
const ReassessmentImprovement = React.lazy(() => import('../AdminView/ReassessmentImprovement'));
const AppointmentFeedback = React.lazy(() => import('../AdminView/AppointmentFeedback'));
const TherapistReimbursementPaid = React.lazy(() => import('../AdminView/TherapistReimbursementPaid'));
const AppointmentUnpaid = React.lazy(() => import('../AdminView/AppointmentUnpaid'));
const TherapistReimbursementInfo = React.lazy(() => import('../AdminView/TherapistReimbursementInfo'));
const AccountReceived = React.lazy(() => import('../AdminView/AccountReceived'));
const AccountReceivable = React.lazy(() => import('../AdminView/AccountReceivable'));
const FirstAppointment = React.lazy(() => import('../AdminView/FirstAppointment'));
const AdminPatientHealthFormNew = React.lazy(() => import('../AdminView/AdminPatientHealthFormNew'));
const PatientDmeSurgical = React.lazy(() => import('../AdminView/PatientDmeSurgical'));
const Cervical = React.lazy(() => import('../components/Cervical'));
const Lumbar = React.lazy(() => import('../components/Lumbar'));
const LowerExtremities = React.lazy(() => import('../components/LowerExtremities'));
const Thoracic = React.lazy(() => import('../components/Thoracic'));
const UpperExtremities = React.lazy(() => import('../components/UpperExtremities'));
const Vestibular = React.lazy(() => import('../components/Vestibular'));
const Reassessment = React.lazy(() => import('../components/Reassessment'));
const PatientRefuseAssessment = React.lazy(() => import('../components/PatientRefuseAssessment'));
const PP_PatientDashboard = React.lazy(() => import('../PatientView/PP_PatientDashboard'));
const PP_MyAppointments = React.lazy(() => import('../PatientView/PP_MyAppointments'));
const PP_SuggestedVideo = React.lazy(() => import('../PatientView/PP_SuggestedVideo'));
const PP_PatientMedicalHistory = React.lazy(() => import('../PatientView/PP_PatientMedicalHistory'));
const PP_StartMeeting = React.lazy(() => import('../PatientView/PP_StartMeeting'));
const PP_PatientBookAppointment = React.lazy(() => import('../PatientView/PP_PatientBookAppointment'));
const CA_Dashboard = React.lazy(() => import('../CompanyAdmin/CA_Dashboard'));
const CA_Overview = React.lazy(() => import('../CompanyAdmin/CA_Overview'));
const QualityAnalysisReport = React.lazy(() => import('../AdminView/QualityAnalysisReport'));
const CA_BookAnAppointment = React.lazy(() => import('../CompanyAdmin/CA_BookAnAppointment'));
const CA_PatientNurse = React.lazy(() => import('../CompanyAdmin/CA_PatientNurse'));
const RequestsForApppointment = React.lazy(() => import('../AdminView/RequestsForApppointment'));
const PatientDischarge = React.lazy(() => import('../AdminView/PatientDischarge'));
const PatientRefusal = React.lazy(() => import('../AdminView/PatientRefusal'));
const ContactUs = React.lazy(() => import('../AdminView/ContactUs'));
const AppointmentFees = React.lazy(() => import('../AdminView/AppointmentFees'));
const SelfPayAppointment = React.lazy(() => import('../AdminView/SelfPayAppointment'));
const PaymentConfirmation = React.lazy(() => import('../PatientView/PaymentConfirmation'));

export default [
    {
        path: '/dashboard',
        secured: false,
        name: 'Dashboard',
        Component: Dashboard,
        role: ['Doctor'],
    },
    {
        path: '/my-profile/:TherapistGUID',
        goBackPath: '/dashboard',
        secured: false,
        name: 'My Profile',
        Component: DoctorProfile,
        role: [],
    },
    {
        path: '/edit-my-profile',
        goBackPath: '/dashboard',
        secured: false,
        name: 'Edit My Profile',
        Component: EditDoctorProfile,
        role: [],
    },
    {
        path: '/my-appoinment',
        goBackPath: '/dashboard',
        secured: false,
        name: 'My Appoinment',
        Component: MyAppoinment,
        role: [],
    },
    {
        path: '/my-workingcalendar',
        goBackPath: '/dashboard',
        secured: false,
        name: 'My Working Calendar',
        Component: MyWorkingCalendar,
        role: [],
    },
    {
        path: '/patient-details',
        goBackPath: '/dashboard',
        secured: false,
        name: 'Patient Details',
        Component: PatientDetails,
        role: [],
    },
    {
        path: '/patient-list',
        goBackPath: '/dashboard',
        secured: false,
        name: 'My Patients',
        Component: PatientList,
        role: [],
    },
    {
        path: '/patient-profile/:PatientGUID/:TherapistGUID',
        goBackPath: '/dashboard',
        secured: false,
        name: 'Patient Profile',
        Component: PatientProfile,
        role: [],
    },
    {
        path: '/patient-prescription/:PatientGUID',
        goBackPath: '/dashboard',
        secured: true,
        name: 'Patient Prescription',
        Component: PatientPrescription,
        role: [],
    },
    {
        path: '/my-schedule',
        goBackPath: '/dashboard',
        secured: false,
        name: 'My Schedule',
        Component: MySchedule,
        role: [],
    },
    {
        path: '/therapistpatienthealthform/:PatientGUID/:AppoinmentGUID?',
        goBackPath: '/dashboard',
        secured: true,
        name: 'Patient Details',
        Component: AdminPatientHealthForm,
        role: [],
    },
    // {
    //     path: '/patientotherassessment/:PatientGUID/:AppoinmentGUID/:AStatus/:AssessmentType',
    //     goBackPath: '/dashboard',
    //     secured: true,
    //     name: 'My Appointment',
    //     Component: PatientOtherAssesment,
    //     role: [],
    // },
    {
        path: '/patientotherassessment/:PatientGUID/:AppoinmentGUID/:AStatus/:AssessmentType?',
        goBackPath: '/dashboard',
        secured: true,
        name: 'My Appointment',
        Component: PatientOtherAssesment,
        role: [],
    },
    {
        path: '/assessment-template',
        goBackPath: '/dashboard',
        secured: true,
        name: 'Assessment Template',
        Component: AssessmentTemplate,
        role: [],
    },
    {
        path: '/therapistpatientphistory/:PatientGUID/:AppoinmentGUID/',
        goBackPath: '/dashboard',
        secured: true,
        name: 'Patient Medical History',
        Component: PatientMedicalHistory,
        role: [],
    },
    {
        path: '/adminpatientphistory/:PatientGUID/:AppoinmentGUID/',
        goBackPath: '/dashboard',
        secured: true,
        name: 'Patient Medical History',
        Component: PatientMedicalHistory,
        role: [],
    },
    {
        path: '/admin/admindashboard',
        secured: false,
        name: '',
        Component: AdminDashboard,
        role: [],
    },
    {
        path: '/adminpatienthealthformNew/:PatientGUID/:AppoinmentGUID',
        // goBackPath: '/companyadmin',
        secured: false,
        name: '',
        Component: AdminPatientHealthFormNew,
        role: [],
    },
    {
        path: '/admin/appointments',
        goBackPath: '/admin/admindashboard',
        secured: false,
        name: 'Patient Chart',
        Component: Appointments,
        role: [],
    },
    {
        path: '/admin/caprisonreport',
        goBackPath: '/admin/admindashboard',
        secured: false,
        name: 'CA Prison Report',
        Component: CAPrisonReport,
        role: [],
    },
    {
        path: '/admin/new-signup',
        goBackPath: '/admin/admindashboard',
        secured: false,
        name: 'New Sign up',
        Component: NewSignUp,
        role: [],
    },
    {
        path: '/admin/registrations',
        goBackPath: '/admin/admindashboard',
        secured: false,
        name: 'Registrations',
        Component: Registrations,
        role: [],
    },
    {
        path: '/admin/patients',
        goBackPath: '/admin/admindashboard',
        secured: false,
        name: 'Patients',
        Component: Patients,
        role: [],
    },
    {
        path: '/admin/payments',
        goBackPath: '/admin/admindashboard',
        secured: false,
        name: 'Payments',
        Component: Payments,
        role: [],
    },
    {
        path: '/admin/marketing',
        goBackPath: '/admin/admindashboard',
        secured: false,
        name: 'Marketing',
        Component: Marketing,
        role: [],
    },
    {
        path: '/admin/approved-therapists',
        goBackPath: '/admin/admindashboard',
        secured: false,
        name: 'Approved Therapists',
        Component: ApprovedTherapists,
        role: [],
    },
    {
        path: '/admin/selfpay-appointments',
        goBackPath: '/admin/admindashboard',
        secured: false,
        name: 'Self Pay Appointments',
        Component: SelfPayAppointment,
        role: [],
    },
    {
        path: '/admin/reassessment-improvement',
        goBackPath: '/admin/admindashboard',
        secured: false,
        name: 'Reassessment Improvement',
        Component: ReassessmentImprovement,
        role: [],
    },
    {
        path: '/admin/appointmentfeedback',
        goBackPath: '/admin/admindashboard',
        secured: false,
        name: 'Appointment Feedback',
        Component: AppointmentFeedback,
        role: [],
    },
    {
        path: '/admin/updatefees',
        goBackPath: '/admin/admindashboard',
        secured: false,
        name: 'Appointment Feedback',
        Component: AppointmentFees,
        role: [],
    },
    {
        path: '/admin/therapist-reimbursement/:id',
        goBackPath: '/admin/admindashboard',
        secured: false,
        name: 'Admin Therapist Reimbursement Paid',
        Component: TherapistReimbursementPaid,
        role: [],
    },
    {
        path: '/admin/therapistappoinments/:TherapistGUID/:id',
        goBackPath: '/admin/admindashboard',
        secured: false,
        name: 'Admin Therapist Reimbursement',
        Component: AppointmentUnpaid,
        role: [],
    },
    {
        path: '/admin/therapistreimbursement-info',
        goBackPath: '/admin/admindashboard',
        secured: false,
        name: 'Therapist Reimbursement Info',
        Component: TherapistReimbursementInfo,
        role: [],
    },
    {
        path: '/admin/account-received',
        goBackPath: '/admin/admindashboard',
        secured: false,
        name: 'Account Received',
        Component: AccountReceived,
        role: [],
    },
    {
        path: '/admin/account-receivable',
        goBackPath: '/admin/admindashboard',
        secured: false,
        name: 'Account Receivable',
        Component: AccountReceivable,
        role: [],
    },
    {
        path: '/admin/first-appointment',
        goBackPath: '/admin/admindashboard',
        secured: false,
        name: 'First Appointment',
        Component: FirstAppointment,
        role: [],
    },
    {
        path: '/admin/requestforappointment',
        goBackPath: '/admin/admindashboard',
        secured: false,
        name: 'Requests For Apppointment',
        Component: RequestsForApppointment,
        role: [],
    },    
    {
        path: '/admin/patientdischarge',
        goBackPath: '/admin/admindashboard',
        secured: false,
        name: 'Admin Patient Discharge',
        Component: PatientDischarge,
        role: [],
    },
    {
        path: '/admin/patientrefusal',
        goBackPath: '/admin/admindashboard',
        secured: false,
        name: 'Admin Patient Refusal',
        Component: PatientRefusal,
        role: [],
    },    
    {
        path: '/admin/patientDmeSurgical',
        goBackPath: '/admin/admindashboard',
        secured: false,
        name: 'DME / Surgical Notes',
        Component: PatientDmeSurgical,
        role: [],
    },
    {
        path: '/admin/contactus',
        goBackPath: '/admin/admindashboard',
        secured: false,
        name: 'Contact Us',
        Component: ContactUs,
        role: [],
    },
    {
        path: '/cervical/:PatientGUID/:AppoinmentGUID/:AStatus',
        secured: true,
        name: 'My Appointment > Cervical',
        Component: Cervical,
        role: [],
    },
    {
        path: '/lumbar/:PatientGUID/:AppoinmentGUID/:AStatus',
        secured: true,
        name: 'My Appointment > Lumbar',
        Component: Lumbar,
        role: [],
    },
    {
        path: '/lowerextremities/:PatientGUID/:AppoinmentGUID/:AStatus',
        secured: true,
        name: 'My Appointment > Lower Extremities',
        Component: LowerExtremities,
        role: [],
    },
    {
        path: '/upperextremities/:PatientGUID/:AppoinmentGUID/:AStatus',
        secured: true,
        name: 'My Appointment > Upper Extremities',
        Component: UpperExtremities,
        role: [],
    },
    {
        path: '/Thoracic/:PatientGUID/:AppoinmentGUID/:AStatus',
        secured: true,
        name: 'My Appointment > Thoracic',
        Component: Thoracic,
        role: [],
    },
    {
        path: '/Vestibular/:PatientGUID/:AppoinmentGUID/:AStatus',
        secured: true,
        name: 'My Appointment > Vestibular',
        Component: Vestibular,
        role: [],
    },
    {
        path: '/Reassessment/:PatientGUID/:AppoinmentGUID/:AStatus',
        secured: true,
        name: 'My Appointment > Reassessment',
        Component: Reassessment,
        role: [],
    },
    {
        path: '/patient/patientdashboard',
        secured: false,
        name: '',
        Component: PP_PatientDashboard,
        role: [],
    },
    {
        path: '/patient/myappointments',
        goBackPath: '/patient/patientdashboard',
        secured: false,
        name: 'My Appointments',
        Component: PP_MyAppointments,
        role: [],
    },
    {
        path: '/patient/sharedvideo',
        goBackPath: '/patient/patientdashboard',
        secured: false,
        name: 'Home Program',
        Component: PP_SuggestedVideo,
        role: [],
    },
    {
        path: '/patient/patientmedicalhistory/:PatientGUID/',
        goBackPath: '/patient/patientdashboard',
        secured: true,
        name: 'Patient Medical History',
        Component: PP_PatientMedicalHistory,
        role: [],
    },
    {
        path: '/patient/patientassessment/:AppoinmentGUID/',
        goBackPath: '/patient/patientdashboard',
        secured: true,
        name: 'Patient Profile > My Appointments',
        Component: PP_StartMeeting,
        role: [],
    },
    {
        path: '/patient/patientbookappointment/:PatientGUID/:state?',
        goBackPath: '/patient/patientdashboard',
        secured: true,
        name: 'Book An Appointment',
        Component: PP_PatientBookAppointment,
        role: [],
    },
    {
        path: '/patient/payment-confirm/:PatientGUID',
        goBackPath: '/patient/patientdashboard',
        secured: true,
        name: 'Payment Confirmed',
        Component: PaymentConfirmation,
        role: [],
    },
    {
        path: '/Patientrefuseassessment/:PatientGUID/:AppoinmentGUID/:AStatus',
        goBackPath: '/patient/patientdashboard',
        secured: true,
        name: 'My Appointment',
        Component: PatientRefuseAssessment,
        role: [],
    },
    {
        path: '/companyadmin/dashboard',
        goBackPath: 'companyadmin/dashboard',
        secured: false,
        name: 'Company Admin Dashboard',
        Component: CA_Dashboard,
        role: [],
    },
    {
        path: '/companyadmin/overview',
        goBackPath: 'companyadmin/dashboard',
        secured: false,
        name: 'Patient Overview',
        Component: CA_Overview,
        role: [],
    },
    {
        path: '/admin/qualityanalysisreport',
        goBackPath: 'admin/admindashboard',
        secured: false,
        name: 'Quality Analysis Report',
        Component: QualityAnalysisReport,
        role: [],
    },
    {
        path: '/companyadmin/adminpatienthealthform/:PatientGUID?',
        goBackPath: 'companyadmin/dashboard',
        secured: false,
        name: 'Patient Details',
        Component: CA_BookAnAppointment,
        role: [],
    },
    {
        path: '/companyadmin/patientnurse',
        goBackPath: 'companyadmin/dashboard',
        secured: false,
        name: 'Register Nurse',
        Component: CA_PatientNurse,
        role: [],
    },
    {
        path: '/adminpatienthealthform/:PatientGUID?',
        goBackPath: '/companyadmin/dashboard',
        secured: false,
        name: 'Patient Details',
        Component: CA_BookAnAppointment,
        role: [],
    },
    {
        path: '/companyadmin/bookappointment/:PatientGUID/:state?',
        goBackPath: '/companyadmin/dashboard',
        secured: true,
        name: 'Book An Appointment',
        Component: PP_PatientBookAppointment,
        role: [],
    }
];